import * as React from 'react';
import {Col, Container, Row} from 'reactstrap';
import PrioritariosForm from './prioritarios-form';
import fileDownload from 'js-file-download';
import MiranaServiceClient from '../../../middleware/mirana-client';
import {lazyInject, TYPES} from '../../../utils/inversify-config';
import {error, success, warning} from '../../../utils/notification-actions';
import {connect} from 'react-redux';
import {getFileName} from '../../../utils/utils';
import {IFuerzaVenta} from '../../../utils/constants';

interface PrioritariosProps {
    fuerzaVenta: IFuerzaVenta;
}

class Prioritarios extends React.PureComponent<ReduxProps & PrioritariosProps> {

    @lazyInject(TYPES.MIRANA_SERVICE)
    public apiClient: MiranaServiceClient;

    constructor(props, state) {
        super(props, state);
        this.handleGenerarExcel = this.handleGenerarExcel.bind(this);
    };

    public async handleGenerarExcel(values) {
        const mesaId = values.mesaId ? values.mesaId.value : null;
        const rutaId = values.rutaId ? values.rutaId.value : null;
        try {
            this.props.dispatch(warning('Notificación', 'El reporte esta siendo generado, por favor espere y no refresque la página'));
            const prioritariosResponse = await this.apiClient.descargarPrioritarios(this.props.fuerzaVenta.id, mesaId, rutaId);
            fileDownload(prioritariosResponse.data, getFileName(prioritariosResponse));
            this.props.dispatch(success('Notificación', 'Excel generado correctamente'));
        } catch (ex) {
            this.props.dispatch(error('Error', 'Error interno al generar excel de indicadores'));
        }
    }

    public render() {
        return (
            <Container>
                <Row>
                    <Col md={12}>
                        <h3 className='page-title'>Prioritarios {this.props.fuerzaVenta.descripcion}</h3>
                    </Col>
                </Row>
                <Row>
                    <Col md={3}>
                        <PrioritariosForm onSubmit={this.handleGenerarExcel} fuerzaVentaId={this.props.fuerzaVenta.id}/>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default connect()(Prioritarios);



// WEBPACK FOOTER //
// ./src/components/pages/prioritarios/prioritarios.tsx